import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { AnchorLinkComponent } from '../../../components/anchor-button/anchor-link.component';
import { LabelsProviderPipe } from '../../../pipes/labels-provider/labels-provider.pipe';
import { GetSensitiveDataActionComponent } from 'src/app/components/get-sensitive-data-input/get-sensitive-data-input.component';
import { Observable } from 'rxjs';
import { ActionGetAgentStepSensitiveDataResponseModel } from 'src/app/services/httpServices/detection/aiAgentStepsHttpService/ai-agent-steps-http.service';

export enum CitationResourceType {
  FILE,
  WEBSITE,
}

export type CitedSource = {
  id: string;
  link: string;
  fileName?: string;
  sensitivityLabelId?: string;
  resourceType: CitationResourceType;
  sensitiveData?: {
    buttonText: string;
    isRawValue: boolean;
    showPopupBtn: boolean;
    sensitiveDataMethod: () => Observable<ActionGetAgentStepSensitiveDataResponseModel>;
  };
};

@Component({
  selector: 'app-ai-agent-citation',
  templateUrl: './ai-agent-citation.component.html',
  styleUrls: ['./ai-agent-citation.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AnchorLinkComponent, CommonModule, LabelsProviderPipe, GetSensitiveDataActionComponent],
})
export class AiAgentCitationComponent {
  citation = input<CitedSource>();

  protected readonly CitationResourceType = CitationResourceType;

  protected readonly resourceTypeIcon = computed(() => {
    switch (this.citation()?.resourceType) {
      case CitationResourceType.WEBSITE:
        return 'assets/images/common/globe.svg';
      case CitationResourceType.FILE:
      default:
        return 'assets/images/common/file.svg';
    }
  });

  protected readonly sensitivity = computed(() => {
    switch (this.citation()?.sensitivityLabelId) {
      case 'High':
        return { label: 'Confidential', icon: 'assets/images/status-icons/shield.svg' };
      case 'Medium':
        return { label: 'Internal', icon: 'assets/images/status-icons/shieldOutlined.svg' };
      default:
        return null;
    }
  });
}
